import { API } from "../../../utils";

export const getEmailLogsApi = async (params) => {
  const response = await API.get("/email-logs", { params });
  return response.data;
};

export const getEmailDetailsApi = async (id) => {
  const response = await API.get(`/email-logs/${id}`);
  return response.data;
};

export const resendEmailApi = async (emailLogId) => {
  const response = await API.post(`email-logs/${emailLogId}/resend`);
  return response.data;
};
